// Single source for blog article images (listing cards, latest-articles, article hero, schema, prerender).
// The article's own image (admin-supplied) always wins; known-dead URLs and empty fields get an
// owned, unlabeled local image matched by topic, else the neutral research image.

const BLOG_FALLBACK_IMAGE = '/images/blog/what-are-research-peptides-hero.png';

// Placeholder from an old build job; returns 403.
const DEAD_IMAGE_PATTERNS = [/\/artifacts\/peptide_lab_default\.jpg(\?.*)?$/i];

const TOPIC_IMAGES = [
  [/stability/, '/images/blog/how-to-store-research-peptides-properly-hero.png'],
  [/storage/, '/images/blog/peptide-storage-best-practices-hero.png'],
  [/-vs-.*(tirzepatide|semaglutide|retatrutide|ipamorelin)|(tirzepatide|retatrutide|cjc-1295).*-vs-/, '/images/blog/tirzepatide-vs-semaglutide-in-research-hero.png'],
  [/bpc-157|tb-500|thymosin/, '/images/blog/bpc-157-vs-tb-500-in-research-hero.png'],
  [/semaglutide|retatrutide|glp-1r/, '/images/blog/understanding-glp1-receptor-agonists-hero.png'],
  [/glp-1|glp1/, '/images/blog/glp-1-research-compounds-explained-hero.png'],
];

const isDeadImage = (url) => DEAD_IMAGE_PATTERNS.some((re) => re.test(url));

function topicImage(slug) {
  const s = String(slug || '').toLowerCase();
  const hit = TOPIC_IMAGES.find(([re]) => re.test(s));
  return hit ? hit[1] : BLOG_FALLBACK_IMAGE;
}

// Returns the image path/URL to render for an article (never empty).
function resolveBlogImage(article) {
  const own = article && (article.featured_image || article.hero_image);
  if (typeof own === 'string' && own.trim() && !isDeadImage(own)) return own;
  return topicImage(article && article.slug);
}

const absoluteImageUrl = (url, siteUrl) =>
  (/^https?:/i.test(url) ? url : `${siteUrl}${url.startsWith('/') ? '' : '/'}${url}`);

// <img onError>: swap once to the neutral local image; if that also fails, hide the img
// (the card's gradient background stays). The data flag makes looping impossible.
function blogImageOnError(e) {
  const img = e.currentTarget;
  if (img.dataset.fallbackApplied) {
    img.style.visibility = 'hidden';
    return;
  }
  img.dataset.fallbackApplied = '1';
  img.removeAttribute('srcset');
  img.src = `${process.env.REACT_APP_BACKEND_URL || ''}${BLOG_FALLBACK_IMAGE.replace(/\.png$/, '.webp')}`;
}

module.exports = { BLOG_FALLBACK_IMAGE, resolveBlogImage, absoluteImageUrl, blogImageOnError };
